export type LogLevel = 'error' | 'warn' | 'info' | 'debug';

export class Logger {
  private debugMode: boolean;
  private prefix = '[Puulso]';

  constructor(debug: boolean = false) {
    this.debugMode = debug;
  }

  setDebug(debug: boolean): void {
    this.debugMode = debug;
  }

  private shouldLog(level: LogLevel): boolean {
    if (!this.debugMode && level !== 'error') {
      return false;
    }
    return true;
  }

  private formatMessage(level: LogLevel, message: string): string {
    const timestamp = new Date().toISOString();
    return `${this.prefix} [${timestamp}] [${level.toUpperCase()}] ${message}`;
  }

  error(message: string, ...args: unknown[]): void {
    if (this.shouldLog('error')) {
      console.error(this.formatMessage('error', message), ...args);
    }
  }

  warn(message: string, ...args: unknown[]): void {
    if (this.shouldLog('warn')) {
      console.warn(this.formatMessage('warn', message), ...args);
    }
  }

  info(message: string, ...args: unknown[]): void {
    if (this.shouldLog('info')) {
      console.info(this.formatMessage('info', message), ...args);
    }
  }

  debug(message: string, ...args: unknown[]): void {
    if (this.shouldLog('debug')) {
      console.debug(this.formatMessage('debug', message), ...args);
    }
  }
}

// Singleton logger instance
export const logger = new Logger();

